import { useMemo } from 'react';

import { useReviews } from 'hooks/data-fetching';
import type { Review, ReviewImage, ReviewScore } from 'models/api';
import type { VariantId } from 'models/product';
import { filterTruthy } from 'utils/collection';

export interface ImageReviewItem extends ReviewImage {
	review: Review;
}

export default function useReviewImages({
	isActive,
	reviewScore,
	variantId,
}: {
	isActive: boolean;
	reviewScore?: ReviewScore;
	variantId: VariantId;
}) {
	const {
		error,
		isLoading,
		items: reviews,
	} = useReviews({
		filter: 'HasImage',
		isActive,
		pageSize: 100,
		reviewScore,
		reviewSorting: 'ScoreDesc',
		variantId,
	});

	const reviewImages: ImageReviewItem[] = useMemo(
		() =>
			filterTruthy(reviews, 'images').flatMap((review) =>
				review?.images.map((image) => ({
					...image,
					review,
				})),
			),
		[reviews],
	);

	return { reviewImages, isLoading, error };
}
